<template>
  <div id="app">
    <transition name="silde"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
export default {
  data () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {

  },
  created () {
    const width = document.body.clientWidth
    const height = document.body.clientHeight
    let ratio = { hole: 1, width: 1, height: 1 }
    ratio.width = (width / 1536).toFixed(2)
    ratio.height = (height / 727).toFixed(2)
    ratio.hole = Math.sqrt(width * height / 1116672).toFixed(2)
    this.$store.commit('setRatio', ratio)
  },
  mounted () {

  }
};
</script>
<style lang="scss">
.silde-enter-active {
  transition: all 0.2s ease;
}
.silde-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.silde-enter, .silde-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: scale(0.9);
  opacity: 0;
}
</style>
